import { useEffect, useState } from "react";

import "./order-tracking.scss";

export type OrderTrackingProps = {
  scriptSrc: string;
};

export const OrderTracking = ({ scriptSrc }: OrderTrackingProps) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = scriptSrc;
    script.async = true;
    script.defer = true;
    script.onload = () => setIsLoading(false);

    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, [scriptSrc]);

  return (
    <div
      className="order-tracking"
      style={{ visibility: isLoading ? "hidden" : "visible" }}
    >
      <div id="tracking-info" />
    </div>
  );
};
